export const membershipHistoryColumns = [
  { field: "name", headerName: "Membership Plan", width: 240 },
  { field: "duration", headerName: "Months", width: 113 },
  { field: "isMultiUserPlan", headerName: "Multi User Plan", width: 157 },
  { field: "renewalDate", headerName: "Renewal Date", width: 157 },
  { field: "expiryDate", headerName: "Expiry Date", width: 177 },
  { field: "orderAmount", headerName: "Order amount", width: 137 }
];
